import { render, staticRenderFns } from "./k-nav-tabs.vue?vue&type=template&id=669f03a8&scoped=true"
import script from "./k-nav-tabs.vue?vue&type=script&lang=js"
export * from "./k-nav-tabs.vue?vue&type=script&lang=js"
import style0 from "./k-nav-tabs.vue?vue&type=style&index=0&id=669f03a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "669f03a8",
  null
  
)

export default component.exports